import FlexPane from './_flex-pane.js'
import ConfigurablePane from './_configurable-pane.js'
import SelectableButton from './_selectable-button.js'
import Text from './_text.js'
import Button from './_button.js'
import RotatableImage from './_rotatable-image.js'

export default {
  name: 'ButtonBar',
  values: {
    enableExpandCollapse: false,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          justifyContent: 'flex-end',
          padding: '4px',
        },
      },
    },
    containerCollapsed: {
      configSet: FlexPane,
      configValues: {
        style: {
          overflow: 'hidden',
          height: '32px',
        },
      },
    },
    containerExpanded: {
      configSet: FlexPane,
      configValues: {
        style: {
          overflow: 'visible',
          height: 'auto',
        },
      },
    },
    buttonWrapper: {
      configSet: FlexPane,
      configValues: {
        useSpacingSeparator: false,
        itemSpacing: '8px',
        style: {
          flexWrap: 'wrap',
        },
      },
    },
    style: {
      newFeature: {
        height: '16px',
        padding: '0px 4px',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
        ],
      },
      newFeatureActive: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
        ],
      },
    },
    button: {
      configSet: SelectableButton,
      configValues: {
        unselected: {
          style: {
            base: {
              padding: '0px 8px',
              minWidth: '100px',
              minHeight: '100%',
              alignItems: 'center',
              overflow: 'hidden',
              flexGrow: 0,
            },
          },
        },
        selected: {
          style: {
            base: {
              padding: '0px 8px',
              minWidth: '100px',
              minHeight: '100%',
              alignItems: 'center',
              flexGrow: 0,
              overflow: 'hidden',
            },
          },
        },
      },
    },
    text: {
      configSet: Text,
      configValues: {
        truncate: true,
        container: {
          flexGrow: 0,
        },
      },
    },
    expandButton: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: '0',
            minWidth: '64px',
            gap: '8px',
            alignItems: 'center',
            maxHeight: '32px',
          },
        },
      },
    },
    expandButtonText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    expandButtonIcon: {
      configSet: RotatableImage,
      configValues: {
        image: {
          src: 'chevron-up',
          style: {
            minWidth: '8px',
            minHeight: '8px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
